






























import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import Editor from '@/components/Editor.vue';
import ModalFormConfig from '@/components/modals/ModalFormConfig.vue';
import ModalFormDelete from '@/components/modals/ModalFormDelete.vue';
import ModalFormDuplicate from '@/components/modals/ModalFormDuplicate.vue';

@Component({
    name: 'Jumbotron',
    components: {
        'editor': Editor,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'b-dropdown-divider': BDropdownDivider,
        'modal-form-config': ModalFormConfig,
        'modal-form-delete': ModalFormDelete,
        'modal-form-duplicate': ModalFormDuplicate,
    },
})
export default class Jumbotron extends Vue {
    @Prop() title!: string;
    @Prop() lead!: string;
    @Prop() form!: Form;
    @Prop() centered!: boolean;

    clientUrl: string = process.env.VUE_APP_CLIENT_URL;
}
